module.exports = __webpack_public_path__ + "static/media/forpatient2.545bebd5.png";